import type { FeatureToggles } from '~~/lib/ContentfulGraphqlService/validation/featureTogglesSchema';
import buildFeatureToggles from '~/utils/buildFeatureToggles';

export default function useModernCheckout(): boolean {
  const { $activeLocale, $globalPageSettings } = useNuxtApp();

  const featureToggles = buildFeatureToggles($globalPageSettings.value) ?? {};
  const featureName = `usewebappCheckout_${$activeLocale.value.webapp}`;

  const featureToggle =
    featureToggles[
      featureName as Exclude<keyof FeatureToggles, 'useContentPageCache'>
    ];

  return featureName in featureToggles && !!featureToggle;
}
